<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'table-manager-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>

      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.table_name }}
          </td>
          <td>
            {{ props.item.created_by.name }}
          </td>
          <td>
            {{ joinUsersName(props.item.users) }}
          </td>
          <td class="text-xs-center">

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id, props.item.table_name)">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import { map as _map } from 'lodash';
import CrudMixin from '@/components/mixins/CrudMixin';
import TableManagerService from '@/features/table-manager/TableManagerService';

export default {
  name: 'table-manager-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('attributes.table_manager.table_name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.table_manager.created_by'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.table_manager.users'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
    };
  },
  methods: {
    initCrud() {
      this.serviceType = TableManagerService;
      this.routerName = 'table-manager';
    },
    joinUsersName(users) {
      let joinNames = 'Nenhum usuário associado';
      if (users.length > 0) {
        const names = _map(users, user => ` ${user.name}`);
        joinNames = names.join(',');
      }
      return joinNames;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/table-manager/TableManagerList.vue